import { checkValue, getMagazinePageLink } from 'src/components/common/helper';

const aspectRatios = ['3:4', '1:1', '3:4', '1:1', '3:4', '3:4'];

const CardTypes = {
  ARTICLE: 'Article Card',
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const genTitle = (children = []) => {
  if (!checkValue(children, true)) return null;
  return children.map((child) => child.text).join(' ');
};

const useArticleReferenceDataMap = (data, sanityStore) => {
  const { autoCardType, cardsAuto } = data;
  if (autoCardType === CardTypes.ARTICLE && cardsAuto) {
    const magazineMainURL = getMagazinePageLink(sanityStore);
    const newCardsAuto = cardsAuto.map((card, index: number) => {
      const { heroSetting, tags, pageUrl2 } = card;
      return {
        _type: 'cardArticle',
        title: heroSetting?.headlineRaw, //genTitle(heroSetting?.headlineRaw?.[0]?.children || []) || '',
        aspectRatio: 'CPDS_4x3',
        image: {
          image: heroSetting?.cmsMedia?.image || heroSetting?.cmsMedia?.videoCover || heroSetting?.videoImage,
          aspectRatio: aspectRatios?.[index] || '1:1',
          altText: heroSetting?.cmsMedia?.altText ?? heroSetting?.cmsMedia?.title,
        }, // TODO: check if video is available
        tags: tags?.tag?.map((tag) => tag?.tag) || [],
        tinyImageLoader: true,
        sponsor: '',
        cta: {
          ctaText: '',
          ctaUrl: checkValue(pageUrl2?.current) ? `${magazineMainURL}${pageUrl2?.current}` : '',
          icon: '',
          openUrlInNewTab: true,
        },
      };
    });
    return {
      ...data,
      cards: newCardsAuto,
    };
  }

  return {
    ...data,
  };
};

export default useArticleReferenceDataMap;
